import { render, staticRenderFns } from "./OTPLogin.vue?vue&type=template&id=c81c6d4a&"
import script from "./OTPLogin.vue?vue&type=script&lang=ts&"
export * from "./OTPLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports